<div class="wrapper" *ngIf="!rowData.isDraft">
  <button *ngIf="isStatusPending()" type="button" class="btn btn-primary" (click)="doSendInvite()">Trimite invitatie</button>
  <button *ngIf="isStatusPending()" type="button" class="btn btn-primary" (click)="doDelete()">Sterge invitatie</button>
  <button *ngIf="isStatusActive()" type="button" class="btn btn-primary" (click)="doSave()">Modifica</button>
  <button *ngIf="isStatusActive()" type="button" class="btn btn-primary" (click)="doInactivate()">Inactiveaza</button>
</div>
<div class="wrapper" *ngIf="rowData.isDraft">
  <button type="button" class="btn btn-primary" (click)="doSendInvite()">Trimite invitatie</button>
  <button type="button" class="btn btn-primary" (click)="doDelete()">Sterge invitatie</button>
</div>
